export interface LoadshopSetting {
  key: string;
  value: string;
}
